"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_inlinesvg_1 = __importDefault(require("react-inlinesvg"));
var pin_svg_1 = __importDefault(require("@lifesize/ux-assets/vectors/svgIcons/pin.svg"));
var core_1 = require("@material-ui/core");
var EventBus_1 = __importDefault(require("../../EventBus"));
var signaling_1 = require("../../signaling");
var ux_assets_1 = require("@lifesize/ux-assets");
var useStyles = core_1.makeStyles(function () { return ({
    container: {
        alignItems: 'center',
        background: 'rgba(50, 50, 50, .4)',
        border: function (props) { return (!props.pinned ? "solid 1px " + ux_assets_1.colors.white : ''); },
        borderRadius: '24px',
        cursor: 'pointer',
        display: 'flex',
        height: '24px',
        justifyContent: 'center',
        left: '5px',
        opacity: function (props) { return (props.visible ? (props.pinned ? 0.3 : 0.5) : 0); },
        position: 'absolute',
        top: '5px',
        transition: 'opacity .25s ease-in-out',
        width: '24px',
        '&:hover': {
            background: 'rgba(50, 50, 50, .6)'
        },
        '&:active': {
            background: 'rgba(50, 50, 50, .8)'
        }
    },
    pin: {
        color: ux_assets_1.colors.white,
        transform: function (props) { return (props.pinned ? '' : 'rotate(45deg)'); },
        width: '100%'
    }
}); });
var pinParticipant = function (payload) { return EventBus_1.default.Subject.next({ type: signaling_1.constants.LAYOUT_PIN_REQUEST, payload: payload }); };
function Pin(props) {
    var participantId = props.participantId, visible = props.visible;
    var pinned = signaling_1.hooks.useMedia().pinned;
    var isPinned = pinned === participantId;
    var pin = react_1.useCallback(function (participantId) {
        if (!participantId)
            return;
        if (participantId === pinned)
            return pinParticipant(signaling_1.constants.SFU_DOMINANT_TALKER);
        pinParticipant(participantId);
    }, [pinned, signaling_1.constants.SFU_DOMINANT_TALKER, pinParticipant]);
    var classes = useStyles({ visible: participantId && (isPinned || visible), pinned: isPinned });
    return (react_1.default.createElement("div", { "data-testid": "pin-video", className: classes.container, onClick: function () { return pin && pin(participantId); } },
        react_1.default.createElement(react_inlinesvg_1.default, { className: classes.pin, src: pin_svg_1.default })));
}
exports.default = Pin;
